type FieldKey =
  | "Existing Customer"
  | "Heard About Us"
  | "Preferred Service Date"
  | "Full Name"
  | "Date"
  | "Email"
  | "Phone"
  | "Zip"
  | "Interest"
  | "Comments"
  | "Hidden"
  | "Custom"
  | "City"
  | "Office"
  | "Address"
  | "State"

export const useFieldDictionary = (fields: FieldKey) => {
  const formFieldDictionary: Record<FieldKey, string> = {
    "Existing Customer": "AreYouanExistingCustomer",
    "Heard About Us": "HowDidYouHearAboutUs",
    "Preferred Service Date": "preferred_date",
    "Full Name": "full_name",
    Date: "date",
    Email: "email",
    Phone: "phone",
    Zip: "zip",
    Interest: "interest",
    Comments: "comments",
    Hidden: "hidden",
    Custom: "custom",
    City: "city",
    Address: "address",
    Office: "office",
    State: "state",
  }
  return formFieldDictionary[fields]
}
